import { render } from "./List.vue?vue&type=template&id=d927c328"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "@/assets/css/tailwind.css?vue&type=style&index=0&lang=css"
import "@/assets/css/_config.css?vue&type=style&index=1&lang=css"
import "@/assets/css/_global.css?vue&type=style&index=2&lang=css"
import "@/assets/css/animations.css?vue&type=style&index=3&lang=css"
import "@/assets/css/main.css?vue&type=style&index=4&lang=css"

import exportComponent from "/efs/www/builder/breakingmed-web-components/beta/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__